<template>
  <div class="container-fluid">
    <!-- Header Section -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="fw-500 text-black mb-0 s-24">Top Performing Campaigns</div>
      <a href="#" class="text-decoration-none text-black">See all</a>
    </div>

    <!-- Campaign Cards Grid -->
    <div class="row">
      <div
        class="col-lg-4 col-md-6 mb-4"
        v-for="campaign in campaigns"
        :key="campaign.id"
      >
        <div class="border-gray-200 campaign-card card border-radius-10 p-2">
          <div class="h-100 border-0 mb-3">
            <div class="card-img-container">
              <img
                :src="campaign.image"
                :alt="campaign.title"
                class="card-img-top campaign-image"
              />
            </div>
            <div class=" d-flex flex-column mt-3">
              <div class="card-title fw-500 text-black mb-3">
                {{ campaign.title }}
              </div>

              <!-- Progress Bar -->
              <div class="progress mb-3" style="height: 6px">
                <div
                  class="progress-bar"
                  :class="getProgressBarClass(campaign.goalReach)"
                  role="progressbar"
                  :style="{ width: campaign.goalReach + '%' }"
                  :aria-valuenow="campaign.goalReach"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              <!-- Campaign Stats -->
              <div
                class="d-flex justify-content-between align-items-center mt-auto"
              >
                <span class="fw-300 text-black s-11"
                  >{{ campaign.participants }} Participants</span
                >
                <span class="fw-300 text-black s-11"
                  >{{ campaign.goalReach }}% goal reach</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import educationImage from "../../../../assets/tempImage/educationcampaign.png";
import healthcampaignImage from "../../../../assets/tempImage/healthcampaign.png";
import soulmissionImage from "../../../../assets/tempImage/soulmission.png";

const campaigns = ref([
  {
    id: 1,
    title: "Education Grant",
    image: educationImage,
    participants: 254,
    goalReach: 100,
  },
  {
    id: 2,
    title: "Kids Health Care Mission",
    image: healthcampaignImage,
    participants: 380,
    goalReach: 80,
  },
  {
    id: 3,
    title: "Save a Soul Mission",
    image: soulmissionImage,
    participants: 25,
    goalReach: 34,
  },
  {
    id: 4,
    title: "Education Grant",
    image: educationImage,
    participants: 254,
    goalReach: 100,
  },
  {
    id: 5,
    title: "Kids Health Care Mission",
    image: healthcampaignImage,
    participants: 380,
    goalReach: 80,
  },
  {
    id: 6,
    title: "Save a Soul Mission",
    image: soulmissionImage,
    participants: 25,
    goalReach: 50,
  },
]);

const getProgressBarClass = (goalReach) => {
  if (goalReach >= 80) return "bg-success";
  if (goalReach >= 50) return "bg-warning";
  return "bg-danger";
};
</script>

<style scoped>
.campaign-card {
  border-radius: 12px;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  overflow: hidden;
}

.campaign-card:hover {
  border-radius: 10px;
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.card-img-container {
  height: 200px;
  overflow: hidden;
}

.campaign-image {
  border-radius: 7px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.campaign-card:hover .campaign-image {
  transform: scale(1.05);
  border-radius: 10px !important;
}


.card-title {
  font-size: 15px;
  line-height: 1.3;
}

.progress {
  border-radius: 10px;
  background-color: #f8f9fa;
}

.progress-bar {
  border-radius: 10px;
  transition: width 0.6s ease;
}

.text-muted {
  color: #6c757d !important;
}

@media (max-width: 768px) {
 

  .card-title {
    font-size: 1rem;
  }
}
</style>
